import { App, defineAsyncComponent } from 'vue';

const Breadcrumb = defineAsyncComponent(() => import('./breadcrumb/Breadcrumb.vue'));
const CaseListItem = defineAsyncComponent(() => import('@/core/components/case/CaseListItem.vue'));
const DocumentViewer = defineAsyncComponent(() => import('@/core/components/documents/DocumentViewer.vue'));

export default async function config(app: App): Promise<void> {
    app.component('Breadcrumb', Breadcrumb);
    app.component('CaseListItem', CaseListItem);
    app.component('DocumentViewer', DocumentViewer);
}
